import angular from 'angular';

angular
  .module('cxHttpServices')
  .factory('templateHttpSvc', ['$http', '$q', 'appUrls', 'checkSecurity', templateHttpSvc]);

function templateHttpSvc($http, $q, appUrls, checkSecurity) {
  var baseUrl = appUrls.api + '/api/Template/';

  function handleSuccess(response) {
    return response.data;
  }

  return {
    getTemplates: function(type) {
      return $http
        .get(baseUrl + 'Company/' + (!type && type !== 0 ? '' : type))
        .then(handleSuccess);
    },
    getTemplate: function(templateId) {
      return $http.get(baseUrl + 'Get/' + templateId).then(handleSuccess);
    },
    getContent: function(templateId, lang) {
      return $http
        .get(baseUrl + 'Content/' + templateId + '/' + (lang || 'nl'))
        .then(handleSuccess);
    },
    getTemplateWithContent: function(templateId) {
      return $http.get(baseUrl + 'Get/' + templateId).then(function(response) {
        var template = response.data;

        // if the template contains document tags, retrieve their respective name and attach them to the template
        var documentTagsPromise =
          template.documentTags && template.documentTags.length && checkSecurity(['Settings:u', 'EmailAndInteractionTemplates:u']) // tags are only relevant if user can edit the template
            ? $http.get(appUrls.documents + '/api/tag').then(function({ data }) {
                if (data && data.length) {
                  template.documentTags = data.filter(x => template.documentTags.includes(x.id));
                }
                return template;
              })
            : undefined;

        var promises = template.languages.map(function(lang) {
          return $http
            .get(baseUrl + 'Content/' + templateId + '/' + (lang.languageCode || 'nl'))
            .then(function(response) {
              lang.content = response.data.content;
              lang.title = response.data.title;
              return lang;
            });
        });

        promises = [...promises, documentTagsPromise];

        return $q.all(promises).then(function() {
          return template;
        });
      });
    },
    getPlaceholders: function() {
      return $http.get(baseUrl + 'MailPlaceholders').then(handleSuccess);
    },
    getGroupPlaceholders: function() {
      return $http.get(baseUrl + 'MailGroupPlaceholders').then(handleSuccess);
    },
    createTemplate: function(companyId, template) {
      return $http.post(baseUrl + 'Template/' + companyId, template).then(handleSuccess);
    },
    copyTemplate: function(templateId) {
      return $http.post(baseUrl + 'Copy/' + templateId).then(handleSuccess);
    },
    updateTemplate: function(template) {
      return $http.put(baseUrl + 'Template', template).then(handleSuccess);
    },
    removeTemplate: function(templateId) {
      return $http.delete(baseUrl + 'Template/' + templateId).then(handleSuccess);
    },
    createLanguage: function(templateId, language) {
      return $http.post(baseUrl + 'CreateLanguage/' + templateId, language).then(handleSuccess);
    },
    validateLanguage: function(templateId, language) {
      return $http.post(baseUrl + 'ValidateLanguage/' + templateId, language).then(handleSuccess);
    },
    updateLanguage: function(templateId, language) {
      return $http.put(baseUrl + 'UpdateLanguage/' + templateId, language).then(handleSuccess);
    },
    removeLanguage: function(templateId, languageId) {
      return $http
        .delete(baseUrl + 'Language/' + templateId + '/' + languageId)
        .then(handleSuccess);
    },
  };
}
